// TODO: Centralise
function clamp(x, min, max) {
  return Math.max(min, Math.min(x, max));
}

// TODO: Centralise
const mobile = matchMedia("(width < 768px)");

class CardContainerElement extends HTMLElement {
  #tr = null;

	#dragging = false;
	#offsetX = 0;
	#offsetY = 0;
	#startOffsetX = 0;
	#startOffsetY = 0;
	#startClientX = 0;
	#startClientY = 0;

  connectedCallback() {
    this.#offsetX = Number(document.documentElement.style.getPropertyValue("--card-x") ?? "0");
    this.#offsetY = Number(document.documentElement.style.getPropertyValue("--card-y") ?? "0");
    addEventListener("click", this);
    this.addEventListener("mousedown", this);
  }

  disconnectedCallback() {
    removeEventListener("click", this);
    this.removeEventListener("mousedown", this);
    removeEventListener("mousemove", this);
    removeEventListener("mouseup", this);
  }

  handleEvent(e) {
    if (e.type === "click") {
      if (this.#dragging && e.composedPath().includes(this)) {
        return;
      }
      const button = e.target.closest("button");
      if (button) {
        const { action } = button.dataset;
        if (action === "card-toggle") {
          this.toggle();
        } else if (action === "card-open") {
          this.toggle(true);
        } else if (action === "card-close") {
          this.toggle(false);
        }
      } else if (!e.composedPath().includes(this) && this.hasAttribute("open")) {
        this.toggle(false);
      }
    } else if (e.type === "mousedown") {
      if (mobile.matches) return;
      e.preventDefault();
      addEventListener("mousemove", this);
      addEventListener("mouseup", this);
      this.dragStart(e);
    } else if (e.type === "mousemove") {
      if (mobile.matches) return;
      e.preventDefault();
      this.dragMove(e);
    } else if (e.type === "mouseup") {
      if (mobile.matches) return;
      removeEventListener("mousemove", this);
      removeEventListener("mouseup", this);
      this.dragEnd();
    }
  }

  dragStart(e) {
    const { clientX, clientY } = e;

    document.documentElement.style.userSelect = "none";

    this.style.touchAction = "none";

    this.#startOffsetX = this.#offsetX;
    this.#startOffsetY = this.#offsetY;

    this.#startClientX = clientX;
    this.#startClientY = clientY;
  }

  dragMove(e) {
    const { clientX, clientY } = e;

    if (Math.abs(clientX - this.#startClientX) + Math.abs(clientY - this.#startClientY) >= 4) {
      this.#dragging = true;
    }

    this.#offsetX = this.#startOffsetX + clientX - this.#startClientX;
    this.#offsetY = this.#startOffsetY + clientY - this.#startClientY;

    document.documentElement.style.setProperty("--card-x", this.#offsetX);
    document.documentElement.style.setProperty("--card-y", this.#offsetY);
  }

  dragEnd() {
    document.documentElement.style.removeProperty("user-select");

    this.style.removeProperty("touch-action");

    requestAnimationFrame(() => {
      this.#dragging = false;
    });
  }

  async toggle(force) {
    const prev = this.hasAttribute("open");
    const details = this.querySelector(".card-details");
    const h = details.scrollHeight;
    const d = document.body.scrollHeight - window.innerHeight;

    const open = this.toggleAttribute("open", force);

    if (open === prev) return;

    if (mobile.matches) {
      window.scrollTo({ top: open ? d : 0, behavior: "smooth" });
    } else {
      this.classList.add("transition");

      if (this.#tr)
        this.#tr.cancel();

      this.#tr = details.animate(
        { height: open ? [0, h+"px"] : [h+"px", 0] },
        { duration: 300, easing: "ease" },
      );

      try {
        await this.#tr.finished;
        this.classList.remove("transition");
      } catch {}
    }
  }
}

customElements.define("card-container", CardContainerElement);
